/* eslint-disable import/no-unused-modules */
import React from 'react';
import styled from 'styled-components';

import { FilterSelect, Select } from '@/ui/Select';
import { Icon } from '@/components/Icon';
import { IconPropType } from '@/ui/Icon';
import { CATALOG_LEARNING_TYPES_OPTIONS } from '@/features/catalog/admin/constants/learning';

type LearningTypeFilterOption = {
  value: string;
  displayValue: string;
  prefixIcon: string[];
};

type LearningTypeFilterProps = {
  selectedLearningType?: string;
  onChange: (learningType: string) => void;
  onTrailingIconClick?: () => void;
  options?: LearningTypeFilterOption[];
};

export const LearningTypeFilter = ({
  selectedLearningType,
  onChange,
  onTrailingIconClick,
  options = CATALOG_LEARNING_TYPES_OPTIONS,
}: LearningTypeFilterProps): JSX.Element => {
  const selectedLearningTypeDisplay =
    selectedLearningType && options.find((learningTypeOption) => learningTypeOption.value === selectedLearningType)?.displayValue;

  return (
    <FilterSelect
      placeholder="Learning type"
      value={selectedLearningTypeDisplay || ''}
      onChange={(value) => onChange(String(value))}
      onTrailingIconClick={onTrailingIconClick}
      variant="dropdown"
    >
      <Select.List>
        {options.sort().map((learningTypeOption) => (
          <Select.Option
            value={learningTypeOption.value}
            key={learningTypeOption.value}
            prefix={<StyledIcon icon={learningTypeOption.prefixIcon as IconPropType} />}
          >
            {learningTypeOption.displayValue}
          </Select.Option>
        ))}
      </Select.List>
    </FilterSelect>
  );
};

const StyledIcon = styled(Icon)`
  width: 14px;
  height: 12px;
`;
